import type { FaireProductEntity } from "../../entity_types/product";

export const p_b6ql8m70l6: FaireProductEntity = {
  token: "p_b6ql8m70l6",
  type: "product",
  name: "Nurturing & Refreshing Conditioner, Neem & Bay Leaf, 10.8 oz",
  brandToken: "b_b6bx4chhb1",
  brandName: "Zatik Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/0c19521ba5d119cdf5abfcd958845fe53e2edd7809fc4ce43e5212fa672dfab9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f893cc016b8002169fc88fad4bff58a018544071d4942b00df1c4a44b3efdebe.png",
    "https://cdn.faire.com/fastly/f47a32935725b3b02d1c214f7c8a7ea36d2071e9461da16dbcd3a67b13b8a098.png",
    "https://cdn.faire.com/fastly/a195945cfa194285c6f8964e28ac7de3d49c06d83f38d0b2ab60974bb74f8c0f.jpeg",
  ],
  priceDollars: 8.4,
  description:
    "Dry, delicate, and fine hair. Neem and bay leaf:\nConditions and detangles the hair leaving with a feel of volume and strength. After a rinse improves the shine, softness and moisture retention. Uplifting herbal scent from combination of essential oils.\nFormulated with essential fatty acids, mineral and nutrient rich plant extracts, vitamins and plant based amino acid protein providing vital benefits for strengthening the hair.\nBottle type: frosted HDP plastic.\nClosure: natural cap.\n10.8 fl oz. 320 ml",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:04.922Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
